<div class="user-details-container">
  <h1 class="user-details-title">User Profile</h1>

  <mat-card class="user-profile-card">
    <mat-card-header>
      <mat-icon mat-card-avatar>person</mat-icon>
      <div class="mat-card-header-text" style="display: flex; align-items: center; width: 100%">
        <div style="display: flex; flex-direction: column">
          <mat-card-title>{{ getUserName() }}</mat-card-title>
          @if (getUserEmail()) {
            <mat-card-subtitle>
              {{ getUserEmail() }}
            </mat-card-subtitle>
          }
        </div>
        <button
          mat-stroked-button
          color="primary"
          (click)="refreshToken()"
          aria-label="Refresh Token"
          style="margin-left: auto"
          >
          <mat-icon>refresh</mat-icon>
          Refresh
        </button>
      </div>
    </mat-card-header>

    <mat-card-content>
      @if (hasRoles()) {
        <div class="roles-section">
          <h2>Roles</h2>
          <mat-list>
            @for (role of getRoles(); track role) {
              <mat-list-item>
                <mat-icon matListItemIcon>verified_user</mat-icon>
                <span matListItemTitle>{{ role }}</span>
              </mat-list-item>
            }
          </mat-list>
        </div>
      }

      <div class="permissions-section">
        <h2>Permissions</h2>
        @if (hasPermissions()) {
          <mat-list>
            @for (permission of getPermissions(); track permission.rsid) {
              <mat-list-item>
                <mat-icon matListItemIcon>security</mat-icon>
                <span matListItemTitle>{{ permission.rsname }}</span>
              </mat-list-item>
              @if (permission.scopes && permission.scopes.length > 0) {
                @for (scope of permission.scopes; track scope) {
                  <mat-list-item
                    class="scope-item"
                    >
                    <mat-icon matListItemIcon>check_circle</mat-icon>
                    <span matListItemTitle>{{ scope }}</span>
                  </mat-list-item>
                }
              }
            }
          </mat-list>
        }

        @if (!hasPermissions()) {
          <div class="no-permissions">
            No permissions found
          </div>
        }
      </div>
    </mat-card-content>

  </mat-card>
</div>
